import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, removeToken } from '@/utils/auth'
import { getUserInfo } from '@/api/user' // 假设获取用户信息的接口

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false, // 是否登录
    userInfo: {} // 用户信息
  },
  mutations: {
    // 更新登录状态和用户信息
    SET_USER_INFO(state, userInfo) {
      state.isLogin = true
      state.userInfo = userInfo
    },
    // 清除登录状态
    CLEAR_USER_INFO(state) {
      state.isLogin = false
      state.userInfo = {}
      removeToken()
    }
  },
  actions: {
    // 获取用户信息（登录后调用）
    async getUserInfo({ commit }) {
      try {
        // 如果有token，获取用户信息
        if (getToken()) {
          const res = await getUserInfo()
          commit('SET_USER_INFO', res)
        }
      } catch (error) {
        // token无效时清除状态
        commit('CLEAR_USER_INFO')
      }
    },
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_USER_INFO')
    }
  }
})
